var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewMsgFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7419 22.7347H14.0297L14.2436 22.5423L19.3671 17.9322L19.6155 17.7087V17.3746V3.5027C19.6155 2.65175 19.2545 2.04447 18.7413 1.67835C18.2733 1.3445 17.7357 1.24942 17.3636 1.25752H3.32424C2.53925 1.19724 1.95323 1.50905 1.60748 2.01319C1.30422 2.4554 1.23665 2.96877 1.2521 3.31383V20.3234V20.3314L1.25227 20.3393C1.27237 21.2911 1.62577 21.9732 2.19309 22.372C2.6942 22.7242 3.26292 22.7842 3.66722 22.7347H13.7419Z",
    fill: "#202124",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0244 17.541H18.5832",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0244 21.7357V17.5825",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91406 4.91406H16.8959",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91406 8.23633H16.8959",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91406 11.3516H16.8959",
    stroke: "white",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27051 14.7158L16.7743 14.7158",
    stroke: "white",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27051 17.9966H12.3366",
    stroke: "white",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51091 15.1348C7.49173 15.2802 7.44618 15.4109 7.37426 15.5272C7.30714 15.6434 7.22083 15.7472 7.11535 15.8386C7.00986 15.9258 6.89 16.0005 6.75574 16.0628C6.62149 16.1209 6.48244 16.1666 6.3386 16.1998L8.05751 18.1615H7.23761L5.96461 16.698C5.82557 16.5361 5.69851 16.4198 5.58343 16.3492C5.47315 16.2745 5.35568 16.2371 5.23102 16.2371V15.7825H5.65535C5.80399 15.7825 5.94543 15.7742 6.07969 15.7576C6.21873 15.7369 6.3434 15.7036 6.45368 15.658C6.56395 15.6082 6.65505 15.5417 6.72698 15.4587C6.80369 15.3756 6.84924 15.2677 6.86363 15.1348H5.10156L5.31733 14.7674H6.83486C6.7917 14.5972 6.69821 14.4602 6.55437 14.3564C6.41052 14.2526 6.21634 14.1965 5.97181 14.1882H5.10156L5.31733 13.8208H8.47465L8.25889 14.1882H7.20885C7.37187 14.346 7.47016 14.5391 7.50372 14.7674H8.47465L8.25889 15.1348H7.51091Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMsgFilled);
export default __webpack_public_path__ + "static/media/viewMsgFilled.391b12a962ea89e2528f97c41f3992c3.svg";
export { ForwardRef as ReactComponent };